export default function Help() {
  return (
    <div className="p-4 sm:p-8">
      <div className="mb-8">
        <h1 className="text-lg font-semibold text-foreground">Help</h1>
      </div>
      <div className="rounded-lg border border-border p-6">
        <p className="text-sm text-muted-foreground">
          Questions or feedback? Please email{" "}
          <a
            href="mailto:hi@supportfyi.com"
            className="text-foreground underline underline-offset-4 hover:text-muted-foreground"
          >
            hi@supportfyi.com
          </a>
        </p>
      </div>
    </div>
  );
}
